import { combineReducers } from 'redux';
import cries from './cries';

const backgammonApp = combineReducers({
  cries
});

export default backgammonApp;



// WEBPACK FOOTER //
// ./src/reducers/index.js